import { Box, Image } from '@mantine/core';

export interface InputImageProps {
  picture: string;
  onPictureClick?(): void;
  screenshotLink?: string;
  disabled?: boolean;
}

export const InputImage: React.FC<InputImageProps> = (props) => {
  return (
    <Box
      component="div"
      style={{
        cursor: !!props?.onPictureClick && !props.disabled ? 'pointer' : 'default',
      }}
      onClick={() => !props.disabled && props.onPictureClick?.()}
    >
      <Image src={props.picture} alt={'web service'} fit="contain" w={20} h={20} opacity={1} />
    </Box>
  );
};
